export default class Backend {
    constructor(url, port) {
        this.url = url
        this.port = port
    }

    prepServer() {
        let url = this.url
        if (this.port) url += `:${ this.port }`

        return url
    }

    async _get(endpoint = '') {
        const response = await fetch(`${this.prepServer()}/${endpoint}`)
        const data = await response.json()
        if (!data.ok) {
            throw new Error(data.error)
        }

        return data.result
    }

    async _getFile(endpoint) {
        const response = await fetch(`${this.prepServer()}/${endpoint}`)
        return await response.json()
    }

    async getTokenInfo(tokenId) {
        return await this._get(`token/${tokenId}`)
    }

    async refreshEvents() {
        return await this._get(`refresh/events?token=ka689dashkBVKHIASD969ydqwp0`);
    }

    async waitTokenOnSale(tokenId) {
        return await this._get(`market/sale/${tokenId}`);
    }

    async waitMarketTrade(tokenId) {
        return await this._get(`market/buy/${tokenId}`);
    }

    async waitTokenWithdraw(tokenId) {
        return await this._get(`market/withdraw/${tokenId}`);
    }

    async waitTokenPriceChanged(tokenId) {
        return await this._get(`market/price/${tokenId}`);
    }

    async waitBid(tokenId, bidId) {
        return await this._get(`market/bid/${tokenId}/${bidId}`);
    }

    async waitUnbid(tokenId, bidId) {
        return await this._get(`market/unbid/${tokenId}/${bidId}`);
    }

    async waitBidAccept(tokenId, bidId) {
        return await this._get(`market/bid/accept/${tokenId}/${bidId}`);
    }

    async renameToken(tokenId, name) {
        if (!window.tronWeb) return false;

        const sign = await window.tronWeb.trx.sign(name);
        const response = await fetch(`/backend/image/${tokenId}/rename`, {
            body: JSON.stringify({name, sign}),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })

        if (response.ok) {
            const res = await response.json();
            if (!res.ok) {
                throw new Error(res.error);
            }
        } else {
            throw new Error(response.statusText)
        }

        return true;
    }

    async getUserMarketLots(address) {
        return await this._get(`market/address/${address}`);
    }

    async getImageInfo(tokenId) {
        return await this._getFile(`img/${tokenId}.json`)
    }

    async getHistory(tokenId) {
        return await this._get(`history/${tokenId}`)
    }

    async getMarketLots() {
        return await this._get('market')
    }

    async getTimestamp() {
        return await this._get('time')
    }

    async getInfo() {
        return await this._get()
    }

    async getBids() {
        return await this._get('bids');
    }

    async getBidsHistory(tokenId) {
        return await this._get(`bids/history/${tokenId}`);
    }

    async getTraits() {
        return await this._get('image/traits');
    }

    async getServerTime() {
        return await this._get(`time`);
    }

    async searchImages(traits, _search = '', _onlyMarket = false, _onlyBid = false, _minPrice = 0, _maxPrice = 0, _sort = SORT_VALUES.TOKEN_ID_ASC, offset = 0, limit = 24) {
        const response = await fetch(`${this.prepServer()}/image/search`, {
            body: JSON.stringify(Object.assign(traits, {offset, limit, _search, _sort, _onlyMarket, _maxPrice, _minPrice, _onlyBid})),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })

        if (response.ok) {
            const res = await response.json();
            if (res.ok) {
                return res.result;
            }

            throw new Error(res.error);
        } else {
            throw new Error(response.statusText)
        }
    }
}


export const SORT_VALUES = {
    TOKEN_ID_ASC: 'tokenId:1',
    TOKEN_ID_DESC: 'tokenId:-1',
    RANK_ASC: 'rank:1',
    RANK_DESC: 'rank:-1',
    LOT_PRICE_ASC: 'lotPrice:1',
    LOT_PRICE_DESC: 'lotPrice:-1',
    NEW_ASC: 'mintedAt:1',
    NEW_DESC: 'mintedAt:-1',
    BID_ASC: 'maxBid:1',
    BID_DESC: 'maxBid:-1'
}